<!-- 
frontend\src\modules\authentication\Login.vue
Author: Author : Andre Baldo (http://github.com/andrebaldo/) -->
<template>
  <v-card>
    <v-card-title primary-title>
      <h1>Se connecter</h1>
    </v-card-title>
    <v-card-text>
      <v-form rounded v-model="isLoginFormValid">
        <v-text-field
          name="email"
          label="Nom d'utilisateur/Email*"
          id="email"
          v-model="email"
          prepend-icon="mdi-account-circle"
          required
          :rules="[checkIsRequired(email)]"
          type="email"
        ></v-text-field>

        <v-text-field
          name="password"
          label="Mot de passe*"
          id="password"
          v-model="password"
          :type="getPasswordFieldType()"
          prepend-icon="mdi-lock"
          :append-icon="getShowPasswordApendIcon()"
          @click:append="toggleShowPassword()"
          :rules="[checkIsRequired(password)]"
          required
        ></v-text-field>

        <v-checkbox
          v-model="rememberMe"
          label="Se souvenir de moi"
        ></v-checkbox>

        <div class="text-center">
          <v-progress-circular indeterminate color="primary" v-if="isProcessing"></v-progress-circular>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        elevation="9"
        :disabled="!isLoginFormValid || isProcessing"
        @click="authenticateUserAndSetToken({email:email, password:password, rememberMe:rememberMe})"
      >Connection</v-btn>
    </v-card-actions>
        <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        x-small
        elevation="9"
        :disabled="isProcessing"
        @click="$store.dispatch('loginForfait', rememberMe)"
      >Connection par forfait</v-btn>
    </v-card-actions>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text x-small @click="showForgotDialog = true">Mot de passe oublié ?</v-btn>
    </v-card-actions>

    <v-dialog v-model="showForgotDialog" max-width="400">
      <v-card>
        <v-card-title>Mot de passe oublié</v-card-title>
        <v-card-text>
          <template v-if="!forgotSent">
            <p>Entrez votre adresse email. Vous recevrez un lien pour réinitialiser votre mot de passe.</p>
            <v-text-field
              v-model="forgotEmail"
              label="Email"
              type="email"
              prepend-icon="mdi-email"
            ></v-text-field>
          </template>
          <template v-else>
            <p>Si cet email est associé à un compte, vous recevrez un lien de réinitialisation dans quelques instants.</p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeForgotDialog">Fermer</v-btn>
          <v-btn
            v-if="!forgotSent"
            color="primary"
            :disabled="!forgotEmail || isForgotProcessing"
            :loading="isForgotProcessing"
            @click="sendForgotPassword"
          >Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Login",
  data: function() {
    return {
      rememberMe: false,
      showPassword: false,
      isLoginFormValid: false,
      email: "",
      password: "",
      firstname: "",
      surname: "",
      showForgotDialog: false,
      forgotEmail: "",
      forgotSent: false,
      isForgotProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      "isProcessing"
    ]),
  },
  methods: {
    getPasswordFieldType: function() {
      if (this.showPassword) {
        return "text";
      } else {
        return "password";
      }
    },
    toggleShowPassword: function() {
      this.showPassword = !this.showPassword;
    },
    getShowPasswordApendIcon: function() {
      if (this.showPassword) {
        return "mdi-eye";
      } else {
        return "mdi-eye-off";
      }
    },
    checkIsRequired: function(value, errorMessage) {
      if (!errorMessage) {
        errorMessage = "Ce champ est nécessaire";
      }
      return !!value || errorMessage;
    },
    async sendForgotPassword() {
      this.isForgotProcessing = true;
      await this.$store.dispatch('forgotPassword', this.forgotEmail);
      this.isForgotProcessing = false;
      this.forgotSent = true;
    },
    closeForgotDialog() {
      this.showForgotDialog = false;
      this.forgotEmail = "";
      this.forgotSent = false;
    },
    ...mapActions(["authenticateUserAndSetToken"]),
  },
}
</script>